import { UserPlus, ClipboardText, ShieldCheck, CheckCircle } from "@phosphor-icons/react";
import { Chapter, Reveal } from "./Reveal";

const STEPS = [
  { n: "01", icon: UserPlus, title: "Connect", text: "Create or access your Rupora account." },
  { n: "02", icon: ClipboardText, title: "Submit", text: "Provide the required transaction details and verification information." },
  { n: "03", icon: ShieldCheck, title: "Verify", text: "Rupora verifies the transaction according to the applicable process." },
  { n: "04", icon: CheckCircle, title: "Complete", text: "Once approved, the transaction is processed and the status is updated." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="border-y border-line/70 bg-pine/40" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
        <Chapter index="03" label="How It Works" />
        <Reveal delay={0.1}>
          <h2 className="max-w-2xl font-display text-4xl font-semibold tracking-tighter text-paper sm:text-5xl">
            Four steps. <span className="text-brand-400">Zero guesswork.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={0.1 + i * 0.08} className="h-full">
              <div
                className="group relative h-full overflow-hidden rounded-3xl border border-line bg-night p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand-500/40 hover:shadow-xl hover:shadow-brand-500/10"
                data-testid={`step-card-${i + 1}`}
              >
                <span className="text-outline font-display absolute -right-2 -top-5 text-[6.5rem] font-bold leading-none">
                  {step.n}
                </span>
                <div className="relative">
                  <div className="mb-14 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500/12 text-brand-400 transition-colors duration-500 group-hover:bg-brand-500 group-hover:text-white">
                    <step.icon size={24} weight="duotone" />
                  </div>
                  <h3 className="font-display text-xl font-semibold tracking-tight text-paper">{step.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mist">{step.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
